export const path = "/crm";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "CRM",
  section: "ALUNA",
  group: "COMERCIAL",
  order: 1,
  roles: [
    "Authenticated",
    "aluna-management",
    "aluna-comercial",
  ],
};
